var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Autocomplete } from '@emburse/ui-core';
export const EmployeeSelect = (_a) => {
    var { userOptions, selectedValue = '' } = _a, rest = __rest(_a, ["userOptions", "selectedValue"]);
    return (_jsx(Autocomplete, Object.assign({ getOptionLabel: (option) => option.displayName || '', isOptionEqualToValue: (option, val) => {
            return option.id === val;
        }, options: userOptions, value: selectedValue }, rest)));
};
